import React, { useEffect } from 'react';

const FocusError = ({ errors, isSubmitting, isValidating }) => {
  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const keys = Object.keys(errors);
      console.log('keys', keys);
      if (keys.length > 0) {
        const selector = `[id=${keys[0]}]`;
        const errorElement = document.querySelector(selector);
        console.log('scrolling to', errorElement);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  }, [errors, isSubmitting, isValidating]);

  return null;
};

export default FocusError;
